
<div class="select-filter ui-placeholder">
  <row class="filter">
    <prefix>
      <input type="checkbox">
    </prefix>
    <column class="row-title" size="25%">
      <div class="dropdown">
        <button class="dropdown-toggle arrow"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
          {{'row' | pluralize(rowsNumber)}} selected
        </button>
        <ul class="dropdown-menu" aria-labelledby="documents-selected-button">
          <li>
            <button class="dropdown-item">Button</button>
          </li>
        </ul>
      </div>
    </column>
  </row>
</div>
